import PropTypes from 'prop-types'
import React from 'react'
import skins from './skins'
import { Helmet } from 'react-helmet-async'
import { Grid, EmbedProductCard } from 'Blocks'
import { skin } from 'Utils'

const Large = props => (
  <div className={`${props.className}`}>
    <Helmet bodyAttributes={{ class: 'embed' }} />
    <Grid pageName="embed">
      {props.products.map((product, index) => (
        <EmbedProductCard
          key={`embed-${product.uuid}`}
          product={product}
          className={`product-${product.uuid}`}
        />
      ))}
    </Grid>
  </div>
)

Large.propTypes = {
  className: PropTypes.string,
  products: PropTypes.array
}

export default skin(Large, skins)
